import React, { createContext, useContext, useState, useCallback } from "react";
import { GridRowId } from "@mui/x-data-grid-pro";
const SelectedItemsContext = createContext(null);
export const SelectedItemsProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [selected, setSelected] = useState<GridRowId[]>([]);
  const setSelectedItems = useCallback((items: GridRowId[]) => {
    if (items.length > 100) {
      setSelected(items.slice(0, 100));
    } else {
      setSelected(items);
    }
  }, []);
  return <SelectedItemsContext.Provider value={[selected, setSelectedItems]} data-sentry-element="SelectedItemsContext.Provider" data-sentry-component="SelectedItemsProvider" data-sentry-source-file="SelectedItemsContext.tsx">
      {children}
    </SelectedItemsContext.Provider>;
};
export const useSelectedItems = () => useContext(SelectedItemsContext);